import React from 'react';
import './header.css';

function Header() {
  return (
    <header className="header-container">
      <div className="header-content">
        {/* Header is minimal - logo and nav are in navbar component */}
      </div>
    </header>
  );
}

export default Header;
